export default "__VITE_ASSET__vB2CFyv2__"